import React, { useState, useEffect, useMemo } from "react";
import Breadcrumb from "../../../CommonComponents/BreadCrumb/BreadCrumb";
import Button from "../../../Elements/Button";
import CustomTable from "../../../CommonComponents/Table/CustomTable";
import { UserTypes } from "../../../../hooks/utils";
import DataPerPage from "../../../CommonComponents/Pagination/DataPerPage";
import SearchComponent from "../../../CommonComponents/SearchComponent/SearchComponent";
import { networkService } from "../../../config/axios";
import AdminPagination from "../../../CommonComponents/Pagination/AdminPagination";
import UserDomainsModal from "../../../Modals/Admin/UserDomainsModal";

const AdminDomainManagePage = () => {
    const [domainUsers, setDomainUsers] = useState([]);
    const [filteredData, setFilteredData] = useState([]); // this is modified by search
    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage, setDataPerPage] = useState(10);

    const [openUserDomains, setOpenUserDomains] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);

    useEffect(() => {
        const fetchDomains = async () => {
            const response = await networkService("admin/get_domain_users.json", "GET");
            const users = response?.data?.users || [];
            setDomainUsers(users);
            setFilteredData(users);
        };
        fetchDomains();
    }, []);

    const indexOfLast = currentPage * dataPerPage;
    const indexOfFirst = indexOfLast - dataPerPage;
    const currentPageData = useMemo(() => {
        return filteredData.slice(indexOfFirst, indexOfLast);
    }, [filteredData, indexOfFirst, indexOfLast]);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const columns = useMemo(() => [
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'Email',
            accessor: 'email',
        },
        {
            Header: 'User Type',
            accessor: 'user_type',
            Cell: ({ row }) => UserTypes[row?.original?.user_type] || ''
        },
        {
            Header: 'Last Login',
            accessor: 'last_seen_at',
        },
        {
            Header: 'Company Name',
            accessor: 'company_name',
        },
        {
            Header: 'Default Domain',
            accessor: 'default_domain',
        },
        {
            Header: 'Domains',
            accessor: 'action',
            Cell: ({ row: { original } }) => (
                <Button
                    text="Domains"
                    classList="success"
                    onClick={() => {
                        setSelectedUserId(original.id);
                        setOpenUserDomains(true);
                    }}
                />
            ),
        },
    ], []);

    return (
        <>
            <Breadcrumb string={'Admin/Domain Manager'} />
            <div className="container kinetizine">
                <div className="show-select1 d-flex mb-2">
                    <div className="mb-2">
                        <DataPerPage dataPerPage={dataPerPage} setDataPerPage={setDataPerPage} />
                        <SearchComponent
                            data={domainUsers}
                            setCurrentPageData={setFilteredData}
                        />
                    </div>
                </div>
                <div className="container">
                    <CustomTable data={currentPageData} columnData={columns} />
                    <AdminPagination
                        dataPerPage={dataPerPage}
                        totalData={filteredData.length}
                        onPageChange={handlePageChange}
                        currentPage={currentPage}
                    />
                </div>
            </div>

            <UserDomainsModal
                openModal={openUserDomains}
                closeModal={() => setOpenUserDomains(false)}
                userId={selectedUserId}
            />
        </>
    );
};

export default AdminDomainManagePage;
